import {
  WhyShareFeedbackSection,
  ReviewCategoriesSection,
  ResponseFollowUpSection,
} from "@features/residential/components";

interface CustomerFeedbackPageProps {
  hero: React.ReactNode;
  feedbackCta?: React.ReactNode;
  footer?: React.ReactNode;
}

export default function CustomerFeedbackPage({ hero, feedbackCta, footer }: CustomerFeedbackPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <WhyShareFeedbackSection />
      <ReviewCategoriesSection />
      {feedbackCta}
      <ResponseFollowUpSection />
      {footer}
    </div>
  );
}
